// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/hero.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Section Styling */
.content-section {
    padding: 1rem 2rem;
    background-color: #f9f9f9;
    text-align: center;
}

.content-title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
}

.content-text {
    font-size: 1.25rem;
    line-height: 1.8;
    max-width: 800px;
    margin: 0 auto;
    color: #333;
}

/* Parallax Banner */
.parallax-banner {
    position: relative;
    height: 65vh;
    background-attachment: initial;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

@supports (-webkit-touch-callout: none) {
    .parallax-banner {
        background-attachment: scroll !important;
    }
}

.parallax-banner.primary-purpose {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

}

@media (max-width: 700px) {
    .parallax-banner {
        height: 40vh;
        background-attachment: initial;

    }
    .content-overlay {
        display: none;
    }
}

@media (min-width: 700px) and (max-width: 769px) {
    .parallax-banner {
        height: 65vh;
        background-attachment: initial;

    }
    .content-overlay {
        display: none;
    }
}

.rotate {
    top: 1px;
    position: relative;
    transform: rotateX(180deg);
}

.shape-fill {
    fill: #fff;
    transform-origin: center;
    transform: rotateY(0deg);
}

.content-overlay {
    background: linear-gradient(to right, #800000, #a83232); /* Burgundy Gradient */
    padding: 1rem;
    text-align: center;
    border-radius: 10px;
    margin: 3.5rem;
    opacity: 0.8;
    box-shadow: 8px 0px 30px 0px black;
    display: none;
}

.section-title {
    font-size: 3rem;
    font-weight: bold;
}

.section-subtitle {
    font-size: 1.25rem;
    font-weight: 300;
}

/* Speaker Meetings Grid */
.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    padding: 2rem 0;
}

.grid-item {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.grid-item:hover {
    transform: translateY(-5px);
}

.speaker-card {
    text-align: center;
    padding: 2rem;
}

.speaker-card img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-bottom: 1rem;
}

.speaker-card h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
}

.speaker-card p {
    font-size: 1rem;
    color: #000;
}

.down-caret {
    bottom: 20px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 2.5rem; /* Larger for visibility */
    color: #555555;
    justify-content: center;
    align-items: center;
    animation: bounce 2s infinite;
    outline: none;
}

.down-caret:hover {
    color: #f7f4f4; /* Slight hover effect */
}
.link-style {
    text-decoration: none;
}

/* Bounce animation */
@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(8px);
    }
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
    .grid-container {
        grid-template-columns: 1fr;
    }

    .section-title {
        font-size: 2rem;
    }

    .section-subtitle {
        font-size: 1.25rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/HomePage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,yDAAgD;;AAEpD;;AAEA;IACI;QACI,YAAY;QACZ,8BAA8B;;IAElC;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,8BAA8B;;IAElC;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,uDAAuD,EAAE,sBAAsB;IAC/E,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB,EAAE,0BAA0B;IAC7C,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,cAAc,EAAE,wBAAwB;AAC5C;AACA;IACI,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,0BAA0B;AAC1B;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* General Section Styling */\n.content-section {\n    padding: 1rem 2rem;\n    background-color: #f9f9f9;\n    text-align: center;\n}\n\n.content-title {\n    font-size: 2.5rem;\n    font-weight: bold;\n    margin-bottom: 1rem;\n}\n\n.content-text {\n    font-size: 1.25rem;\n    line-height: 1.8;\n    max-width: 800px;\n    margin: 0 auto;\n    color: #333;\n}\n\n/* Parallax Banner */\n.parallax-banner {\n    position: relative;\n    height: 65vh;\n    background-attachment: initial;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    -webkit-background-size: cover;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n}\n\n@supports (-webkit-touch-callout: none) {\n    .parallax-banner {\n        background-attachment: scroll !important;\n    }\n}\n\n.parallax-banner.primary-purpose {\n    background-image: url(\"/public/assets/hero.jpg\");\n\n}\n\n@media (max-width: 700px) {\n    .parallax-banner {\n        height: 40vh;\n        background-attachment: initial;\n\n    }\n    .content-overlay {\n        display: none;\n    }\n}\n\n@media (min-width: 700px) and (max-width: 769px) {\n    .parallax-banner {\n        height: 65vh;\n        background-attachment: initial;\n\n    }\n    .content-overlay {\n        display: none;\n    }\n}\n\n.rotate {\n    top: 1px;\n    position: relative;\n    transform: rotateX(180deg);\n}\n\n.shape-fill {\n    fill: #fff;\n    transform-origin: center;\n    transform: rotateY(0deg);\n}\n\n.content-overlay {\n    background: linear-gradient(to right, #800000, #a83232); /* Burgundy Gradient */\n    padding: 1rem;\n    text-align: center;\n    border-radius: 10px;\n    margin: 3.5rem;\n    opacity: 0.8;\n    box-shadow: 8px 0px 30px 0px black;\n    display: none;\n}\n\n.section-title {\n    font-size: 3rem;\n    font-weight: bold;\n}\n\n.section-subtitle {\n    font-size: 1.25rem;\n    font-weight: 300;\n}\n\n/* Speaker Meetings Grid */\n.grid-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2rem;\n    padding: 2rem 0;\n}\n\n.grid-item {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n}\n\n.grid-item:hover {\n    transform: translateY(-5px);\n}\n\n.speaker-card {\n    text-align: center;\n    padding: 2rem;\n}\n\n.speaker-card img {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    margin-bottom: 1rem;\n}\n\n.speaker-card h3 {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n}\n\n.speaker-card p {\n    font-size: 1rem;\n    color: #000;\n}\n\n.down-caret {\n    bottom: 20px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 2.5rem; /* Larger for visibility */\n    color: #555555;\n    justify-content: center;\n    align-items: center;\n    animation: bounce 2s infinite;\n    outline: none;\n}\n\n.down-caret:hover {\n    color: #f7f4f4; /* Slight hover effect */\n}\n.link-style {\n    text-decoration: none;\n}\n\n/* Bounce animation */\n@keyframes bounce {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(8px);\n    }\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n    .grid-container {\n        grid-template-columns: 1fr;\n    }\n\n    .section-title {\n        font-size: 2rem;\n    }\n\n    .section-subtitle {\n        font-size: 1.25rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
